// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NavigationBar__NavigationBar___3hXkv{border-radius:4px;display:flex;flex-direction:column;margin:auto auto 8px;width:32px}.NavigationBar__HorizontalSeparator___17vwm{margin:8px;max-width:16px}.spectrum--light .NavigationBar__HorizontalSeparator___17vwm{background:var(--spectrum-global-color-gray-200)}.spectrum--dark .NavigationBar__HorizontalSeparator___17vwm{background:#494949}", ""]);
// Exports
exports.locals = {
	"NavigationBar": "NavigationBar__NavigationBar___3hXkv",
	"HorizontalSeparator": "NavigationBar__HorizontalSeparator___17vwm"
};
module.exports = exports;
